import React, { useId, useState } from 'react';
import axios from 'axios';
import { authApi } from '../../Auth/userSession';
import './ServiceReviewForm.css';

const MAX_FEEDBACK_LENGTH = 2000;
const RATINGS = [1, 2, 3, 4, 5];
const LOGIN_REQUIRED_MESSAGE = '로그인 후 이용할 수 있습니다. 로그인해주세요.';
const REVIEW_ERROR_MESSAGES = {
    400: '별점과 피드백 내용을 다시 확인해주세요.',
    401: LOGIN_REQUIRED_MESSAGE,
};
const SERVER_ERROR_MESSAGE = '서버에 문제가 생겼어요. 문의하기에서 문의주세요.';

// 리뷰 전송 실패 원인을 사용자에게 보여줄 문구로 바꾼다.
function reviewErrorMessage(error) {
    if (axios.isCancel(error)) return LOGIN_REQUIRED_MESSAGE;
    return REVIEW_ERROR_MESSAGES[error.response?.status] || SERVER_ERROR_MESSAGE;
}

// 별점과 피드백을 POST /api/review로 보낸다.
async function submitReview(rating, feedback) {
    await authApi.post('/api/review', { rating, feedback });
}

// 종합 피드백 화면 사이드바의 별점·피드백 입력 카드.
export default function ServiceReviewForm() {
    const id = useId();
    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState('');

    // 폼 제출 시 리뷰를 보내고 결과 상태를 바꾼다.
    const handleSubmit = async event => {
        event.preventDefault();
        if (!rating || status === 'sending') return;
        setStatus('sending');
        setError('');
        try {
            await submitReview(rating, feedback.trim());
            setStatus('done');
        } catch (failure) {
            if (process.env.NODE_ENV !== 'production') console.error(failure);
            setError(reviewErrorMessage(failure));
            setStatus('idle');
        }
    };

    if (status === 'done') {
        return <section className="review-card service-review" aria-live="polite"><h2>소중한 의견 감사합니다</h2><p className="ai-small">남겨주신 별점과 피드백은 서비스 개선에 활용됩니다.</p></section>;
    }

    return (
        <section className="review-card service-review" aria-labelledby={id + '-title'}>
            <h2 id={id + '-title'}>이번 피드백은 어떠셨나요?</h2>
            <p className="ai-small">별점과 의견을 남겨주시면 더 나은 피드백을 만드는 데 활용합니다.</p>
            <form onSubmit={handleSubmit}>
                <fieldset className="service-review-stars">
                    <legend className="sr-only">별점 선택</legend>
                    {RATINGS.map(value => <label key={value} className={value <= rating ? 'on' : ''}>
                        <input type="radio" name={id + '-rating'} value={value} checked={rating === value} aria-label={`${value}점`} onChange={() => setRating(value)} />
                        <span aria-hidden="true">★</span>
                    </label>)}
                </fieldset>
                <label className="sr-only" htmlFor={id + '-feedback'}>피드백</label>
                <textarea id={id + '-feedback'} value={feedback} maxLength={MAX_FEEDBACK_LENGTH} rows={4} placeholder="좋았던 점이나 아쉬운 점을 자유롭게 적어주세요." onChange={event => setFeedback(event.target.value)} />
                <p className="ai-small service-review-count">{feedback.length.toLocaleString()} / {MAX_FEEDBACK_LENGTH.toLocaleString()}자</p>
                {error && <p className="service-review-error" role="alert">{error}</p>}
                <button type="submit" className="review-primary" disabled={!rating || status === 'sending'}>{status === 'sending' ? '보내는 중…' : '의견 보내기'}</button>
            </form>
        </section>
    );
}
